import { createSlice } from "@reduxjs/toolkit";
import { fetchManufacturingRecord } from "./ManufacturingRecordThunk";

const initialState = {
  list: [],
  loading: false,
  accessType: "WRITE", // later could be dynamic
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null, // 👈 separate field
    toDate: null,
  },
};

const manufacturingRecordSlice = createSlice({
  name: "manufacturingRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchManufacturingRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchManufacturingRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchManufacturingRecord.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = manufacturingRecordSlice.actions;
export default manufacturingRecordSlice.reducer;
